import { routeName } from './routeName';
// 허브셀렉터에는 여러가지 타입이 있다.
// 특정 페이지가 어떤 타입인지를 설정한다.
// src/router-middleware/hub-selector.ts와 중복되는데 hubSelectorTypeMapper를 살리는 쪽으로 할 예정이다.
export const hubSelectorTypeMapper = {
    // 관제그룹
    // 총판도 선택할 수 있다.
    control: [
        routeName.MAP_CONTROL,
        routeName.DELIVERY_HISTORY,
        // 목록관제
        // 아래 임시 타입은 페이지 타입 확정 전까지만 제공.
        routeName.TEMPORARY,
    ],
    // 허브셀렉터 타입
    // TODO 허브셀렉터 관련으로 이름 변경 필요 20240327 윤태건
    // https://barogo-my.sharepoint.com/:x:/p/sarah_kim/EZjMMQ6wws5ItrkNTy_De2AB1VkfD1cOircZAPZ3EjG1KQ?e=SbfHiS
    // 총판 계정만 선택 가능한 타입
    // 허브셀렉터 노출 + 총판 선택된 상태로 비활성
    type0: [
        // 허브 > 관리
        routeName.HUB_MANAGEMENT,
        // 허브 > 관리 > 등록
        routeName.HUB_MANAGEMENT_CREATE,
    ],
    // 총판, 특정 허브 모두 선택 가능한 기본 타입
    type1: [
        // 라이더 > 관리
        routeName.WORKER_MANAGEMENT,
        // 라이더 > 바로머니 내역
        routeName.WORKER_BAROMONEY_HISTORY,
        // 라이더 > 수익
        routeName.WORKER_PROFIT,
        // 라이더 > 출근표
        routeName.WORKER_MONTHLY_ATTENDANCE,
        // 상점 > 관리
        routeName.STORE_MANAGEMENT,
        // 정책관리 > 사용자 관리
        routeName.USER_MANAGEMENT,
        routeName.USER_MANAGEMENT_CREATE,
        routeName.USER_MANAGEMENT_PAGE,
        // 상점 > 관리
        routeName.HUB_MANAGEMENT,
        // 정책 > 공유
        routeName.SHARE_MANAGEMENT,
        routeName.OPERATION_SETTING,
    ],
    // 계정 타입, 권한에 따라 타 허브 조회가 가능한 페이지 (총판이냐 허브냐 타허브 조회 권한이 있느냐)
    // control 타입과 명확한 차이 분석 필요
    type2: [
        routeName.WELCOME,
        routeName.MAP_CONTROL,
        routeName.DELIVERY_HISTORY,
        routeName.OPERATION_SETTING,
        // 목록관제
        // 아래 임시 타입은 페이지 타입 확정 전까지만 제공.
        routeName.TEMPORARY,
    ],
    // 반드시 특정 허브 1개가 선택되어야 하는 페이지
    // 총판 선택 불가.
    // 총판 선택된 상태로 진입시 대표 허브로 변경
    type3: [
        // 바로머니 리포트
        routeName.BAROMONEY_REPORT,
        routeName.BAROMONEY_REPORT_BASIC,
        routeName.BAROMONEY_REPORT_PERIOD_COMPARISON,
        // 라이더 > 관리 > 등록
        routeName.WORKER_MANAGEMENT_WORKER_CREATE,
        // 라이더 > 관리 > 그룹 설정
        routeName.WORKER_MANAGEMENT_CASH_AUTO_DEDUCT_GROUP_SETTING,
        routeName.WORKER_MANAGEMENT_DELIVERY_FEE_GROUP_SETTING,
        routeName.WORKER_MANAGEMENT_ALLOCATED_CANCEL_PENALTY_GROUP_SETTING,
        // 라이더 > 정산
        routeName.WORKER_ADJUSTMENT,
        routeName.WORKER_INFORMATION_DETAIL,
        // 라이더 > 통계
        // 상점 > 정산
        routeName.STORE_ADJUSTMENT,
        routeName.STORE_ADJUSTMENT_DETAIL,
        // 상점 > 관리 > 등록
        routeName.STORE_MANAGEMENT_CREATE,
        // 상점 > 관리 > 그룹 설정
        routeName.STORE_MANAGEMENT_WORKER_FEE_PER_STORE_GROUP_SETTING,
        // 상점 > 통계
        // 허브 > 정산
        routeName.HUB_ADJUSTMENT,
        // 정책 > 공유 > 설정
        routeName.SHARE_MANAGEMENT,
        // 정책 > 구역 > 구역설정
        routeName.DELIVERY_CHARGE_AREA_CONTROL,
    ],
    // 상세 또는 수정 페이지라서 허브 변경이 되면 안됨
    // 허브 셀렉트 박스 미노출
    type4: [
        // 라이더 > 관리 > 상세
        routeName.WORKER_MANAGEMENT_WORKER_DETAIL,
        // 라이더 > 관리 > 수정
        routeName.WORKER_MANAGEMENT_WORKER_EDIT,
        routeName.WORKER_MANAGEMENT_WORKER_EDIT_WORK_INFO,
        routeName.WORKER_MANAGEMENT_WORKER_EDIT_PRIVATE_INFO,
        routeName.WORKER_MANAGEMENT_WORKER_EDIT_DELIVERY_SETTING,
        // 라이더 > 정산 > 상세
        // 상점 > 관리 > 상세
        routeName.STORE_MANAGEMENT_DETAIL,
        // 상점 > 관리 > 상세 > 수정
        routeName.STORE_MANAGEMENT_EDIT,
        routeName.STORE_MANAGEMENT_EDIT_BASIC_INFO,
        routeName.STORE_MANAGEMENT_EDIT_FEE_SETTING,
        routeName.STORE_MANAGEMENT_EDIT_OPERATION_SETTING,
        // 허브 > 관리 > 상세
        routeName.HUB_MANAGEMENT_DETAIL,
        // 허브 > 관리 > 상세 > 수정
        routeName.HUB_MANAGEMENT_EDIT,
        routeName.HUB_MANAGEMENT_EDIT_BASIC_INFO,
        routeName.HUB_MANAGEMENT_EDIT_WORKER_OPERATION_SETTING,
        routeName.HUB_MANAGEMENT_EDIT_ADJUSTMENT_OPERATION_SETTING,
        // 허브 > 정산
        routeName.HUB_ADJUSTMENT_DAILY_SALES,
        routeName.HUB_ADJUSTMENT_DAILY_SALES_DETAIL,
        routeName.HUB_ADJUSTMENT_DAILY_PURCHASE,
        // 정책 > 공유 > 설정
        routeName.SHARE_MANAGEMENT_CONFIG,
    ],
    /** 비활성 */
    // 비활성화 하려고 type5를 만들었으나 리팩토링을 많이 해야 해서 일단은
    // src/router-middleware/hub-selector.ts 를 사용한다.
    type5: [],
};
